var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mediaBreakpointDown, mediaBreakpointUp, mergeWithComponentCustomizedStyles, setColorOpacity, sizes } from 'conversional-theme';
import { generateClasses } from '../../utilities/components/styles';
import get from 'lodash/get';
var Styles = function (theme, options, mobileSvgWidth) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var cardHover = get(options, 'cardHover', true);
    return mergeWithComponentCustomizedStyles(theme, 'singleImageSelect', {
        genericOptionContainer: {
            position: 'relative',
            height: '100%'
        },
        imageContainer: {
            position: 'relative'
        },
        imageContainerMobile: (_a = {
                position: 'relative',
                height: '100%'
            },
            _a[mediaBreakpointDown(sizes.xs)] = {
                width: '36%'
            },
            _a),
        disabledOverlay: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: setColorOpacity(theme.colors.carbon, 40),
            top: 0,
            right: 0,
            zIndex: 1,
            cursor: 'not-allowed',
        },
        disabledOverlayText: {
            opacity: 0,
            position: 'absolute',
            width: 'calc(100% - 20px)',
            height: '100%',
            top: 0,
            right: 10,
            color: theme.colors.surface,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: '200ms opacity',
            textAlign: 'center',
            fontWeight: 500,
            zIndex: 2,
            cursor: 'not-allowed',
            ':hover': {
                opacity: 1,
            },
        },
        container: __assign(__assign({ backgroundColor: theme.colors.surface_dark, borderRadius: theme.borders.borderRadius, display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'top', 
            // Commented out for spacing optimization
            // margin: '11px 7.5px',
            marginBottom: 0, overflow: 'hidden', position: 'relative' }, (cardHover
            ? {
                ':hover': {
                    boxShadow: "0 3px 5px ".concat(theme.colors.shadowDark),
                },
                cursor: 'pointer',
            }
            : {})), { ':nth-child(1n) img': {
                width: '100%',
                height: 'auto',
            } }),
        overlapContainer: (_b = {
                backgroundColor: theme.colors.surface_dark,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'top',
                // Commented out for spacing optimization
                // margin: '11px 7.5px',
                marginBottom: 0,
                overflow: 'hidden',
                position: 'relative',
                ':hover': {
                    boxShadow: "0 3px 5px ".concat(theme.colors.shadowDark),
                },
                ':nth-child(1n) img': {
                    width: '100%',
                    height: 'auto',
                }
            },
            _b[mediaBreakpointDown(sizes.sm)] = {
                flexDirection: 'row',
                minHeight: '70px',
                ':nth-child(1n) img': {
                    height: '100%',
                    borderRadius: '0px',
                },
            },
            _b),
        withMobileSVGContainer: (_c = {
                width: '150px',
                minWidth: '150px',
                backgroundColor: theme.colors.surface_dark,
                borderRadius: theme.borders.borderRadius,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                marginBottom: 0,
                overflow: 'hidden',
                position: 'relative',
                ':hover': {
                    boxShadow: "0 3px 5px ".concat(theme.colors.shadowDark),
                },
                ':nth-child(1n) img': {
                    width: '100%',
                    height: 'auto',
                }
            },
            _c[mediaBreakpointDown(sizes.sm)] = {
                width: '100%',
                minWidth: '100%',
            },
            _c[mediaBreakpointDown(sizes.xs)] = {
                flexDirection: 'row',
                minHeight: '70px',
                ':nth-child(1n) img': {
                    height: '100%',
                    borderRadius: '0px',
                },
                borderRadius: '0px',
                padding: '10px',
                position: 'relative',
            },
            _c),
        newContainer: (_d = {
                // width: '150px',
                minWidth: '150px',
                backgroundColor: theme.colors.surface_dark,
                borderRadius: theme.borders.borderRadius,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                marginBottom: 0,
                overflow: 'hidden',
                position: 'relative',
                ':hover': {
                    boxShadow: "0 3px 5px ".concat(theme.colors.shadowDark),
                },
                ':nth-child(1n) img': {
                    width: '100%',
                    height: 'auto',
                }
            },
            _d[mediaBreakpointDown(sizes.sm)] = {
                width: '100%',
                minWidth: '100%',
                flexDirection: 'column'
            },
            _d[mediaBreakpointDown(sizes.xs)] = {
                minHeight: '70px',
                ':nth-child(1n) img': {
                    height: '100%',
                    borderRadius: '0px',
                },
                borderRadius: '0px',
                padding: '5px',
                position: 'relative',
            },
            _d),
        newOverlapContainer: (_e = {
                width: '150px',
                minWidth: '150px',
                backgroundColor: theme.colors.surface_dark,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'top',
                marginBottom: 0,
                overflow: 'hidden',
                position: 'relative',
                ':hover': {
                    boxShadow: "0 3px 5px ".concat(theme.colors.shadowDark),
                },
                ':nth-child(1n) img': {
                    width: '100%',
                    height: 'auto',
                }
            },
            _e[mediaBreakpointDown(sizes.xs)] = {
                width: '100%',
                minHeight: '70px',
                ':nth-child(1n) img': {
                    height: '100%',
                    borderRadius: '0px',
                },
            },
            _e),
        selectedIcon: (_f = {
                width: '100%',
                height: '100%',
                borderRadius: theme.borders.borderRadius,
                position: 'absolute',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: "2px solid ".concat(theme.colors.brand),
                transition: 'all 0.1s',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            },
            _f[mediaBreakpointDown(sizes.sm)] = {
                display: 'none',
            },
            _f),
        selectedIconMobile: (_g = {
                display: 'none',
                width: '100%',
                height: '100%',
                borderRadius: theme.borders.borderRadius,
                position: 'absolute',
                backgroundColor: 'rgba(0,0,0,0.2)',
                border: "2px solid ".concat(theme.colors.brand),
                transition: 'all 0.1s',
                justifyContent: 'center',
                alignItems: 'center'
            },
            _g[mediaBreakpointDown(sizes.sm)] = {
                display: 'flex',
            },
            _g[mediaBreakpointDown(sizes.xs)] = {
                position: 'absolute',
                top: '0px',
                left: '0px',
                bottom: '0px',
                right: '0px',
                borderRadius: '0px',
                zIndex: 2,
            },
            _g),
        iconContainer: {
            right: 5,
            bottom: 5,
        },
        mobilePixelContainer: (_h = {},
            _h[mediaBreakpointDown(sizes.sm)] = {
                position: 'relative',
                height: '100%',
                padding: '10px 0px 10px 10px'
            },
            _h),
        svgContainer: (_j = {
                position: 'relative',
                justifyContent: 'center',
                display: 'flex',
                height: 123,
                backgroundColor: theme.colors.carbon_alphaMedium
            },
            _j[mediaBreakpointDown(sizes.sm)] = {
                backgroundColor: 'transparent',
                minWidth: '100px',
                height: '100%',
            },
            _j[mediaBreakpointDown(sizes.xs)] = {
                alignItems: 'center',
                backgroundColor: 'transparent',
                minHeight: '65px',
                padding: '10px',
            },
            _j),
        svgImage: {
            margin: 20,
        },
        overlapSvgImage: (_k = {},
            _k[mediaBreakpointDown(sizes.sm)] = {
                width: '100px !important',
                display: 'block',
            },
            _k),
        overlapSvgContainer: (_l = {},
            _l[mediaBreakpointDown(sizes.sm)] = {
                width: 'fit-content',
                margin: '4px',
                backgroundColor: 'transparent',
                padding: '5px 25px',
                display: 'grid',
                placeItems: 'center',
                height: 'auto',
            },
            _l),
        pixelImage: {
            width: '100%',
            display: 'block',
            borderRadius: theme.borders.borderRadius,
        },
        overlapPixelImage: {
            width: '100%',
            display: 'block',
        },
        subTitle: __assign(__assign({ letterSpacing: '0px', height: 19 }, theme.text.h4), { fontFamily: theme.typo.fonts.bold, color: theme.colors.textDark }),
        overlapTextContainer: (_m = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'auto',
                marginBottom: 0,
                padding: '8px 10px 4px 10px',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                minWidth: '80%'
            },
            _m[mediaBreakpointDown(sizes.sm)] = {
                minWidth: '60%',
                padding: '10px',
                position: 'static',
                transform: 'none',
                alignItems: 'start',
            },
            _m),
        largeImageTextContainerMobile: (_o = {},
            _o[mediaBreakpointDown(sizes.sm)] = {
                height: '50px',
            },
            _o),
        subTitleOnImageContainer: (_p = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'auto',
                marginBottom: 0,
                padding: 0,
                backgroundColor: '#fff',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                minWidth: '80%'
            },
            _p[mediaBreakpointDown(sizes.sm)] = {
                minWidth: '60%',
                padding: '10px',
                position: 'static',
                transform: 'none',
                alignItems: 'start',
                flexDirection: 'column-reverse',
            },
            _p),
        textContainer: __assign({ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: 10, height: '100%' }, (mobileSvgWidth ? (_q = {},
            _q[mediaBreakpointDown(sizes.xs)] = {
                flex: 1,
                margin: 0,
                marginLeft: 20,
                alignItems: 'start',
            },
            _q) : {})),
        blackBackground: (_r = {
                background: '#181818',
                bottom: 1
            },
            _r[mediaBreakpointDown(sizes.sm)] = {
                background: '#fff',
                bottom: 0,
            },
            _r),
        title: __assign(__assign({}, theme.text.h3), { letterSpacing: 0, fontFamily: theme.typo.fonts.bold, color: theme.colors.carbon, textAlign: 'center' }),
        largeTitle: (_s = {},
            _s[mediaBreakpointDown(sizes.sm)] = {
                alignSelf: 'start',
                padding: 10,
            },
            _s),
        overlapTitle: {
            fontFamily: theme.typo.fonts.bold,
            color: '#181818',
        },
        whiteOverlapTitle: (_t = {
                fontFamily: theme.typo.fonts.bold,
                color: '#fff'
            },
            _t[mediaBreakpointDown(sizes.sm)] = {
                color: theme.colors.text,
                textAlign: 'left',
            },
            _t),
        subTitleOnImageTitle: (_u = {
                fontFamily: theme.typo.fonts.regular,
                color: '#181818',
                padding: '10px 0'
            },
            _u[mediaBreakpointDown(sizes.sm)] = {
                padding: 0,
            },
            _u),
        subTitleOnImageSubtitle: __assign(__assign({}, theme.text.h4), (_v = { fontFamily: theme.typo.fonts.regular, color: '#fff', backgroundColor: '#181818', width: '100%', padding: 1 }, _v[mediaBreakpointDown(sizes.sm)] = {
            backgroundColor: '#fff',
            color: theme.colors.textLight,
            textAlign: 'initial',
            fontWeight: theme.typo.fonts.regular,
        }, _v)),
        subOptionParentOptionContainer: (_w = {
                display: 'flex',
                flexDirection: 'row',
                position: 'relative',
                marginTop: -12,
                width: "100%"
            },
            _w[mediaBreakpointDown(sizes.md)] = {
                flexDirection: 'column'
            },
            _w),
        subOptionsContainer: (_x = {
                display: 'flex',
                alignItems: 'flex-start',
                width: '100%',
                marginTop: 11
            },
            _x[mediaBreakpointUp(sizes.md)] = {
                position: 'absolute',
                top: 0,
                left: '100%',
            },
            _x[mediaBreakpointDown(sizes.md)] = {
                marginBottom: 12,
                marginLeft: 7.5
            },
            _x),
        subOptionsImage: {
            height: '100% !important',
            maxWidth: '74px !important',
            borderRadius: '0 !important',
            marginRight: 6
        }
    });
};
export var getStyles = function (theme, options, mobileSvgWidth) { return generateClasses(function () { return Styles(theme, options, mobileSvgWidth); })(theme); };
